import { render, staticRenderFns } from "./LoginCert.vue?vue&type=template&id=1b41a21a&scoped=true"
import script from "./LoginCert.vue?vue&type=script&lang=ts"
export * from "./LoginCert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b41a21a",
  null
  
)

export default component.exports